export { WeeklyReport } from './WeeklyReport';
